module.exports = __webpack_public_path__ + "img/dinner_title--available.a57a54b6.png";